import { render, staticRenderFns } from "./BillInvoiceDetail.vue?vue&type=template&id=6833fd76"
import script from "./BillInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./BillInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./BillInvoiceDetail.vue?vue&type=style&index=0&id=6833fd76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports